(() => {
  const scrollToTopWhenStepChanged = () => {
    const tabs = document.querySelector('.cpb-panels-container .cpb-panels-tabs');
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
      tabs.scrollIntoView();
    })
  }

  function customAddToCart() {
        if (!!window._cpb.settings === false) window._cpb.settings = {}
        window._cpb.settings.addToCartOverride = async data => {

            data.items.forEach(item => {
              const properties = item.properties
              for (let i in properties) {
                if (['SKU', 'weight', '_image', '_configId', '_productUrl', '_cpb_frs_id'].includes(i)) {
                  delete properties[i];
                }
              }
            })

            fetch("/cart/add.js", {
                "headers": {
                    "content-type": "application/json;charset=UTF-8"
                },
                "body": JSON.stringify({
                    items: data.items
                }),
                "method": "POST"
            }).then(() => {
                if(data.redirect) location.href = '/cart'
            })
        }
    }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    if (window.innerWidth > 999) scrollToTopWhenStepChanged();
    customAddToCart();
  })
})()